export enum CraveErrorType {
  GENERIC = 'GENERIC',
  NETWORK = 'NETWORK',
  SERVER = 'SERVER',
  APPLICATION = 'APPLICATION',
  PLAYBACK = 'PLAYBACK',
}

export enum CraveErrorCode {
  //RTE - Metadata (GraphQL)
  SCREEN_NOT_READY_1001 = '1001',
  MEDIA_ID_NOT_FOUND_1002 = '1002',
  LIVE_CHANNELS_UNAVAILABLE_1003 = '1003',

  //RTE - Cravings (REST)
  INVALID_FORMAT_1400 = '1400',
  MY_LIST_NOT_FOUND_1401 = '1401',
  MEDIA_ID_NOT_FOUND_1402 = '1402',
  INVALID_FORMAT_1403 = '1403',
  INTERNAL_SERVER_ERROR_1405 = '1405',

  //UM
  BAD_REQUEST_2010 = '2010',
  INTERNAL_SERVER_ERROR_2012 = '2012',
  INTERNAL_SERVER_ERROR_2015 = '2015',
  INTERNAL_SERVER_ERROR_2024 = '2024',
  BAD_REQUEST_2025 = '2025',

  //Jasper
  PLAYER_NOT_INITIALIZED_3100 = '3100',

  //Generic Error List
  NO_NETWORK_CONNECTION_4001 = '4001',
  GENERIC_ERROR_4002 = '4002',
  CONNECTION_ERROR_4003 = '4003',
}
